<html>

    <head>
          
    </head>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    <body class="dx-viewport">

        <dx-box
            direction="row"
            width="100%"
            height="100%"
        >
            <!------------------------------------------------------------------------->
            <dxi-item
                [ratio]="5" 
            >     

                <dx-box
                    direction="col"
                    width="100%"
                    height="100%"
                >

                    <dxi-item
                        [ratio]="5"
                    >

                        <dx-data-grid 
                            #grideventcollaborator
                            id="grideventcollaborator"

                            keyExpr="id"

                            [dataSource]="subscriptioncollaboratorlist" 
                            noDataText="No Collaborator Listed"   

                            [allowColumnReordering]="false"
                            [allowColumnResizing]="true"
                            [showRowLines]="true"
                            [showColumnLines]="false"
                            [showBorders]="true"
                            [repaintChangesOnly]="true"

                            [focusedRowEnabled]="true"
                            [hoverStateEnabled]="true"
                            [autoNavigateToFocusedRow]="true"

                            (onCellPrepared)="datagrideditorPreparing( $event )" 
                           
                            (onRowClick)="onrowCollaboratorclick($event)"
                           
                            (onFocusedRowChanged)="onrowCollaboratorchange($event)"

                            (onCellHoverChanged)="onCellHoverCollaborator($event)"

                            (onRowPrepared)="onRowPrepared($event)"
                            (onCellPrepared)="onCellPrepared($event)"
                            

                    width="100%"
                    height="98%"
                >
                    <!------------------------------------------------------------------------->
                    <dxo-filter-row
                        [visible]="true"
                    >
                    </dxo-filter-row>

                    <dxo-header-filter 
                        [visible]="true"
                    >
                    </dxo-header-filter>
                    <!------------------------------------------------------------------------->
                   
                    <dxo-sorting
                        mode="single"> <!-- or "multiple" | "none" -->
                    </dxo-sorting>

                    <dxo-selection
                        mode="single"
                    >
                    </dxo-selection>

                    <dxo-load-panel
                        [enabled]="false">
                    </dxo-load-panel>

                    <dxo-editing 
                        mode="popup"                            
                        [allowUpdating]="true"
                        [allowDeleting]="true"
                        [allowAdding]="true"
                        [useIcons]="true"
                    >
                    </dxo-editing>
                    <!------------------------------------------------------------------------->
                    <dxi-column
                        dataField="id"
                        caption="id"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="0%"
                    >
                    </dxi-column>   

                    <dxi-column
                        dataField="category"
                        caption="Category"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"

                        width="26%"

                        [groupIndex]="0"
                    >

                        <dxi-validation-rule 
                            type="required"
                            message="Please Enter Category">
                        </dxi-validation-rule>

                    </dxi-column>   

                    <dxi-column
                        dataField="providername"
                        caption="Collaborator"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="26%"
                    >

                        <dxi-validation-rule 
                            type="required"
                            message="Please Enter Collaborator">
                        </dxi-validation-rule>

                    </dxi-column>   

                    <dxi-column
                        dataField="contactperson"
                        caption="Contact/Person Name"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="26%"

                        headerCellTemplate="contactpersonHeaderTemplate"
                    >
                    </dxi-column>

                    <div *dxTemplate="let info of 'contactpersonHeaderTemplate'">
                        Contact Person / 
                        <br>
                        Name Person
                    </div>

                    <dxi-column
                        dataField="mobile"
                        caption="Mobile"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="22%"
                    >
                    </dxi-column>

                    <dxi-column
                        dataField="budget"
                        caption="Budget"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [visible]="true"

                        alignment="right"

                        [format]="{ type: 'fixedPoint', precision: 2 }"

                        [allowFiltering]="true"
                        [allowHeaderFiltering]="false"
                        
                        width="15%"
                    >
                        
                    </dxi-column>

                    <dxi-column
                        dataField="amount"
                        caption="Actual"
                        [allowEditing]="true" 
                        [allowSorting]="false"

                        [visible]="true"

                        alignment="right"

                        [format]="{ type: 'fixedPoint', precision: 2 }"

                        [allowFiltering]="true"
                        [allowHeaderFiltering]="false"

                        width="15%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="statuslist"
                        caption="Status"
                        [allowEditing]="true" 
                        [allowSorting]="false"

                        [visible]="true"
                        
                        [allowFiltering]="false"
                        [allowHeaderFiltering]="true"

                        width="11%"

                        cellTemplate="cellStatusIcon"
                    >
                        
                        <div *dxTemplate="let data of 'cellStatusIcon'">

                            <container-element [ngSwitch]="data.value">

                                <div *ngSwitchCase="'Listed'"><i class="fa-regular fa-circle-question fa-2x center"></i></div>

                                <div *ngSwitchCase="'Shortlist'"><i class="fa-regular fa-circle-dot fa-2x center"></i></div>

                                <div *ngSwitchCase="'Confirm'"><i class="fa-regular fa-circle-check fa-2x center"></i></div>

                            </container-element>
                            
                        </div>

                    </dxi-column>
                    <!------------------------------------------------------------------------->
                    <dxo-summary>

                        <dxi-group-item
                            column="budget"
                            summaryType="sum"
                            [showInGroupFooter]="false"

                            [alignByColumn]="true"
                        

                            [customizeText]="format_categorytotal"
                        >
                        </dxi-group-item>

                        <dxi-group-item
                            column="amount"
                            summaryType="sum"
                            [showInGroupFooter]="false"
                            [alignByColumn]="true"

                            [customizeText]="format_categorytotal"
                        >
                        </dxi-group-item>

                        <dxi-total-item
                            column="budget"
                            displayFormat="{0}"
                            summaryType="sum"
                        >

                            <dxo-value-format 
                                type="fixedPoint" 
                                [precision]="2"
                            >
                            </dxo-value-format>

                        </dxi-total-item>

                        <dxi-total-item
                            column="amount"
                            
                            displayFormat="{0}"
                            summaryType="sum"
                        >

                            <dxo-value-format 
                                type="fixedPoint" 
                                [precision]="2"
                            >
                            </dxo-value-format>

                        </dxi-total-item>
                     
                    </dxo-summary>    
                    <!------------------------------------------------------------------------->
                    <dxi-column 
                        type="buttons" 
                        [width]="50"

                        headerCellTemplate="AllocCostsHeaderTemplate"
                        
                    >
                        <dxi-button
                            id="btncostallocation"
                            hint="Click here to allocate cost"
                            icon="fa-sharp fa-solid fa-calculator"
                            [onClick]="collaboratorcostallocclick"
                        >
                        </dxi-button>

                    </dxi-column>

                    <div *dxTemplate="let info of 'AllocCostsHeaderTemplate'">
                        Allocate
                        <br>
                        Cost
                    </div>
                    <!------------------------------------------------------------------------->
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>

                                <dx-button
                                    text=""
                                    [icon]="iconcollapseexpand" 
                                    (onClick)="groupshowcollapse( $event )"
                                >
                                </dx-button>

                                <dx-button
                                    text="Add"
                                    icon="refresh" 
                                    (onClick)="collaboratorform( $event, 10)"
                                >

                                </dx-button>

                                <dx-button
                                    text="Edit"
                                    icon="refresh" 
                                    [disabled]="buttondisable"
                                    (onClick)="collaboratorform( $event, 20)"
                                >
                                </dx-button>
                            </div>
                        </dxi-item>
                    </dxo-toolbar>
                    <!------------------------------------------------------------------------->
                    
                </dx-data-grid>

                    </dxi-item>
                     <!------------------------------------------------------------------------->
                     <dxi-item
                        [ratio]="0.05" 
                    >  
             
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="3"
                    >
                       
                        <dx-box
                            direction="row"
                            width="100%"
                            height="100%"
                        >

                            <dxi-item
                                [ratio]="1"
                            >
                                    <!------------------------------------------------------------------------->
                                    <dx-data-grid 
                                        #grideventexpensecategory
                                        id="grideventexpensecategory"
        
                                        keyExpr="id"
        
                                        [dataSource]="subscriptionfinancecategorylist" 
                                        noDataText="No Categoy Expense Listed"   
        
                                        [allowColumnReordering]="false"
                                        [allowColumnResizing]="true"
                                        [showRowLines]="true"
                                        [showColumnLines]="false"
                                        [showBorders]="true"
                                        [repaintChangesOnly]="true"
        
                                        [focusedRowEnabled]="true"
                                        [hoverStateEnabled]="true"
                                        [autoNavigateToFocusedRow]="true"
        
                                        width="100%"
                                        height="98%"
                                    >
                                        <!------------------------------------------------------------------------->
                                        <dxi-column
                                            dataField="category"
                                            caption="Expense Category Confirmed"
                                            [allowEditing]="false" 
                                            [allowSorting]="false"
                                            [visible]="true"
                                            width="50%"
                                        >
                                        </dxi-column>

                                        <dxi-column
                                            dataField="budget"
                                            caption="Budget"
                                            [allowEditing]="false" 
                                            [allowSorting]="false"

                                            [format]="{ type: 'fixedPoint', precision: 2 }"

                                            [visible]="true"
                                            width="25%"
                                        >
                                        </dxi-column>

                                        <dxi-column
                                            dataField="actual"
                                            caption="Actual"
                                            [allowEditing]="false" 
                                            [allowSorting]="false"

                                            [format]="{ type: 'fixedPoint', precision: 2 }"

                                            [visible]="true"
                                            width="25%"
                                        >
                                        </dxi-column>
                                        <!------------------------------------------------------------------------->
                                        <dxo-summary>

                                            <dxi-total-item
                                                column="budget"
                                                displayFormat="{0}"
                                                summaryType="sum"
                                            >

                                                <dxo-value-format 
                                                    type="fixedPoint" 
                                                    [precision]="2"
                                                >
                                                </dxo-value-format>

                                            </dxi-total-item>
                    
                                            <dxi-total-item
                                                column="actual"
                                                displayFormat="{0}"
                                                summaryType="sum"
                                            >

                                            <dxo-value-format 
                                                type="fixedPoint" 
                                                [precision]="2"
                                            >
                                            </dxo-value-format>

                                            </dxi-total-item>
                                         
                                        
                                        </dxo-summary>    
                                        <!------------------------------------------------------------------------->
                                    </dx-data-grid>
                                    <!------------------------------------------------------------------------->

                            </dxi-item>
                            <!------------------------------------------------------------------------->
                            <dxi-item
                                [ratio]="1"
                                class="rectangleinfosquare"
                            >
                                    Cost Allocation
                                    <ng-template [ngIf]="statusflag == 'Confirm'">

                                        <div>Content to render when condition is true.</div>
        
                                        <dx-data-grid 
                                            #gridealloccost
                                            id="gridealloccost"
        
                                            [dataSource]="organisercostallocation"
                                            keyExpr="id"
        
                                            width="70%"
                                            height="87%"
                                            
                                            [repaintChangesOnly]="true"
        
                                            (onRowUpdated)="updateShareCost($event)"
                                        >
                                            <!------------------------------------------------------------------------->
                                            <dxo-editing 
                                                mode="row"                            
                                                [allowUpdating]="true"
                                                [allowDeleting]="false"
                                                [allowAdding]="false"
                                                [useIcons]="true"
                                            >
                                            </dxo-editing>
                                            <!------------------------------------------------------------------------->
                                            <dxo-summary [calculateCustomSummary]="calculateShareCostSummary">
        
                                                <dxi-total-item
                                                    column="percallocation"
                                                    displayFormat="% Total: {0}"
                                                    summaryType="sum"
                                                >
                                                </dxi-total-item>
        
                                                <dxi-total-item
                                                    name="ShareCostSummary"
                                                    summaryType="custom"
                                                    showInColumn="Your Share"
                                                    displayFormat="$ Total: {0}"
                                                >
                                                </dxi-total-item>
        
                                            </dxo-summary> 
                                            <!------------------------------------------------------------------------->
                                            <dxi-column
                                                dataField="id"
                                                caption="id"
                                                [allowEditing]="false" collaboratorform
                                                [allowSorting]="false"
                                                [visible]="true"
                                                width="20%"
        
                                                cellTemplate="cellparticipantname"
                                            >
        
                                                 <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                                                <div *dxTemplate="let d of 'cellparticipantname'">
                                                    <div>{{whoseguest | getinitial: d.value: whoseguest.length: 1 }}</div> 
                                                </div>  
                                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
                                            </dxi-column> 
        
        
                                            <dxi-column
                                                dataField="confirmcost"
                                                caption="Cost Amount"
                                                [allowEditing]="false" 
                                                [allowSorting]="false"
                                                [visible]="false"
                                                width="30%"
                                            >
                                            </dxi-column>
        
                                            <dxi-column
                                                datafield="calcsharecost"
                                                caption="Your Share"
                                                [allowEditing]="false" 
                                                [allowSorting]="false"
                                                [visible]="true"
                                                width="30%"
        
                                                [calculateCellValue]="ShareCost"
                                            >
                                            </dxi-column>
        
                                            
                                            <dxi-column
                                                dataField="percallocation"
                                                caption="% of Cost"
                                                [allowEditing]="true" 
                                                [allowSorting]="false"
                                                [visible]="true"
                                                width="20%"
        
                                                [setCellValue]="SetShareCost"
                                            >
                                            </dxi-column> 
        
                                        </dx-data-grid>
        
                                    </ng-template>

                            </dxi-item>
                            <!------------------------------------------------------------------------->

                        </dx-box>
                        <!------------------------------------------------------------------------->
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                </dx-box>
                <!------------------------------------------------------------------------->
            </dxi-item>
            <!------------------------------------------------------------------------->
            <dxi-item
                [ratio]="2.5"
                class="rectangleinfosquare"      
            >     
                <!------------------------------------------------------------------------->
                <dx-box
                    direction="col"
                    width="100%"
                    height="60%"
                >
                    <dxi-item
                        [ratio]="1"
                    >   

                        <dx-box
                            direction="row"
                            width="100%"
                            height="100%"
                        >

                            <dxi-item
                                [ratio]="1"
                            >   
                                <div class="paddmargin10">Phone:</div>
                            </dxi-item>

                            <dxi-item
                                [ratio]="3"
                                class="rectangleinfo"      
                            >   
                                <div></div>
                            </dxi-item>
                        </dx-box>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.05" 
                    >  
                    
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="1" 
                    >

                        <dx-box
                            direction="row"
                            width="100%"
                            height="100%"
                        >
                            <dxi-item
                                [ratio]="1"
                            >   
                                <div class="paddmargin10">Email:</div>
                            </dxi-item>

                            <dxi-item
                                [ratio]="3"
                                class="rectangleinfo"      
                            >   
                                <div></div>
                            </dxi-item>
                        </dx-box>

                    </dxi-item>
                     <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.05" 
                    >  
                    
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="1"    
                    >   

                        <dx-box
                            direction="row"
                            width="100%"
                            height="100%"
                        >
                            <dxi-item
                                [ratio]="1"
                            >   
                                <div class="paddmargin10">Street:</div>
                            </dxi-item>

                            <dxi-item
                                [ratio]="3"
                                class="rectangleinfo"      
                            >   
                                <div></div>
                            </dxi-item>
                        </dx-box>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.05" 
                    >  
                
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="1"   
                    >  
            
                        <dx-box
                            direction="row"
                            width="100%"
                            height="100%"
                        >
                            <dxi-item
                                [ratio]="1"
                            >   
                                <div class="paddmargin10">Suburb:</div>
                            </dxi-item>

                            <dxi-item
                                [ratio]="3"
                                class="rectangleinfo"      
                            >   
                                <div></div>
                            </dxi-item>
                        </dx-box>
                
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.05" 
                    >  
                
                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="4"
                    
                    >   
                        <dx-box
                            direction="row"
                            width="100%"
                            height="100%"
                        >
                            <dxi-item
                                [ratio]="1"
                            >   
                                <div class="paddmargin10">Notes:</div>
                            </dxi-item>

                            <dxi-item
                                [ratio]="3"
                                class="rectangleinfo"      
                            >   

                                <dx-text-area
                                    value="collaboratordetails[0].notes"
                                    [autoResizeEnabled]="false"
                                    width="100%"
                                    height="95%"
                                    [readOnly]="true"
                                    >
                                </dx-text-area>
                            
                            </dxi-item>

                        </dx-box>

                    </dxi-item>
                    <!-------------------------------------------------------------------------> 

                </dx-box>
                <!------------------------------------------------------------------------->

            </dxi-item>
            <!------------------------------------------------------------------------->
        </dx-box>
        <!------------------------------------------------------------------------->
        <!--xxxxxxxxxxxxxxxxxxxxxxCOLLABORATOR POPUPxxxxxxxxxxXxxxxxxxxxxxxx-->
        <dx-popup
            id="popupformcollaborator"
            [title] = "popuptitle"
            [hideOnOutsideClick]="false"
            [visible]="popupcollaboratorVisible"
            height="90%"
            width="35%"
        >
         <!------------------------------------------------------------------------->
         <dxo-position
             at="left top"
         >
             <dxo-offset
                 [x]="400" 
                 [y]="320"
             >
             </dxo-offset>

         </dxo-position>
         <!------------------------------------------------------------------------->
         <dxi-toolbar-item
             widget="dxButton"
             location="after"
             toolbar="bottom"

             [options]="{
                             text: 'Save',
                             type: 'success',
                             onClick: saveCollaboratorClick
                         }"

         >
         </dxi-toolbar-item>

         <dxi-toolbar-item
             widget="dxButton"
             location="after"
             toolbar="bottom"

             [options]="{
                             text: 'Cancel',
                             onClick: cancelCollaboratorClick
                         }"

         >
         </dxi-toolbar-item>
         <!------------------------------------------------------------------------->
         <dx-form 
             #formcollaborator
             [(formData)]="formcollaboratorData"
         
             [showColonAfterLabel]="true"  
             labelMode="outside"
             labelLocation="top"

             (onFieldDataChanged)="formCollaboratorDatafldchange( $event )"
             
             [colCount]="3"
         >
            <!------------------------------------------------------------------------->
             <dxi-item
                dataField="category"
                editorType ="dxSelectBox"

                [editorOptions]="{  
                                    placeholder: 'Select/Enter Expense Category', 
                                    inputAttr: { autocomplete: 'chrome-off'},
                                    dataSource: selcategorylist, 
                                    value: selcategory,
                                
                                    acceptCustomValue: true,
                                    onCustomItemCreating: newcategory,

                                    onValueChanged: changcategory,

                                    displayExpr: 'category', 
                                    valueExpr: 'category'  
                                }"

                 [colSpan]="3"
             >      
                 <dxo-label 
                     template="name"
                     text="Expense Category"
                 >
                 </dxo-label>

                 <dxi-validation-rule
                     type="custom"
                     [reevaluate]="true"
                     [validationCallback]="validcollabstatus" 
                     [message]="collabstatusinputvalmsg"
                 >
                 </dxi-validation-rule> 

              
             </dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item
                 dataField="statuslist"
                 editorType ="dxSelectBox"
                
                 [editorOptions]="{  width: 180, 
                                     height: 40, 
                                     placeholder: 'Enter Status', 
                                     inputAttr: { autocomplete: 'chrome-off'},
                                     items: this.collaboratorstatus, value: this.selcollaboratorstatus
                                 }"
             >      
                 <dxo-label 
                     template="name"
                     text="Status"
                 >
                 </dxo-label>

                 <dxi-validation-rule
                     type="custom"
                     [reevaluate]="true"
                     [validationCallback]="validcollabstatus" 
                     [message]="collabstatusinputvalmsg"
                 >
                 </dxi-validation-rule> 

             </dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item
                 dataField="budget"
                 editorType="dxNumberBox"
                 [editorOptions]="{  width: 150, 
                                     height: 40, 
                                     placeholder: 'Enter Budget Cost', 
                                     inputAttr: { autocomplete: 'chrome-off'}
                                 }"
             >
                 <dxo-label 
                     template="name"
                     text="Budget Cost"
                 >
                 </dxo-label>     

                 <dxi-validation-rule
                     type="custom"
                     [reevaluate]="true"
                     [validationCallback]="validbudgetinput" 
                     [message]="budgetinputvalmsg"
                 >
                 </dxi-validation-rule>

             </dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item
                 dataField="amount"
                 editorType="dxNumberBox"
                 [editorOptions]="{  width: 150, 
                                     height: 40, 
                                     placeholder: 'Enter Actual Cost', 
                                     inputAttr: { autocomplete: 'chrome-off'}
                                 }"
             >
                 <dxo-label 
                     template="name"
                     text="Actual Cost"
                 >
                 </dxo-label>     

                 <dxi-validation-rule
                     type="custom"
                     [reevaluate]="true"
                     [validationCallback]="validbudgetinput" 
                     [message]="budgetinputvalmsg"
                 >
                 </dxi-validation-rule>

             </dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item 
                 itemType="group" 
                 caption="Collaborator"
                 [colCount]="3"
                
             >
                 <dxi-item
                     dataField="providername"
              
                     [editorOptions]="{  width: 165, 
                                         height: 40, 
                                     
                                         placeholder: 'Enter Collaborator', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >

                     <dxo-label 
                         template="name"
                         text="Collaborator Name"
                     >
                     </dxo-label>      

                     <dxi-validation-rule 
                         type="required"
                         message="Collaborator is required"
                     >
                     </dxi-validation-rule>

                 </dxi-item>

                 <dxi-item
                     dataField="contactperson"
                   
                     [editorOptions]="{  width: 150, 
                                         height: 40, 
                                         placeholder: 'Enter Contact Person', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >
                     <dxo-label 
                         template="name"
                         text="Contact Person"
                     >
                     </dxo-label>     

                 </dxi-item>

                 <dxi-item
                     dataField="mobile"

                     [editorOptions]="{  width: 145, 
                                         height: 40, 
                                         placeholder: 'Enter Mobile', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >

                     <dxo-label 
                         template="mobile"
                         text="MOB"
                     >
                     </dxo-label>     

                 </dxi-item>

                 <dxi-item
                     dataField="phone"

                     [editorOptions]="{  width: 165, 
                                         height: 40, 
                                         placeholder: 'Enter Phone', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >

                     <dxo-label 
                         template="mobile"
                         text="Phone"
                     >
                     </dxo-label>     

                 </dxi-item>

                 <dxi-item
                     dataField="email"
                     [colSpan]="2"
                     [editorOptions]="{  width: 300, 
                                         height: 40, 
                                         placeholder: 'Enter Email', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >

                     <dxi-validation-rule
                         type="email"
                         message="Email is invalid"
                     >
                     </dxi-validation-rule>

                     <dxo-label 
                         template="mobile"
                         text="Email"
                     >
                     </dxo-label>     

                 </dxi-item>

                 <dxi-item
                     dataField="notes"
                     editorType="dxTextArea"
                     [colSpan]="3"
                     [editorOptions]="{  width: 470, 
                                         height: 50, 
                                         placeholder: 'Enter Notes', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"

                 >
                     <dxo-label 
                         template="note"
                         text="Notes"
                     >
                     </dxo-label>    
                 </dxi-item>

             </dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
             <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
             <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
             <!------------------------------------------------------------------------->
             <dxi-item 
                 itemType="group" 
                 caption="Address"
                 [colCount]="4"
            
             >
                 <dxi-item
                     dataField="street"
             
                     [editorOptions]="{  width: 130, 
                                         height: 40, 
                                         placeholder: 'Enter Street', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >
                     <dxo-label 
                         template="name"
                         text="street"
                     >
                     </dxo-label>     

                 </dxi-item>

                 <dxi-item
                     dataField="suburb"
             
                     [editorOptions]="{  width: 115, 
                                         height: 40, 
                                         placeholder: 'Enter Suburb', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >
                     <dxo-label 
                         template="name"
                         text="Suburb"
                     >
                     </dxo-label>     

                 </dxi-item>

                 <dxi-item
                     dataField="state"
             
                     [editorOptions]="{  width: 113, 
                                         height: 40, 
                                         placeholder: 'Enter State', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >
                     <dxo-label 
                         template="name"
                         text="State"
                     >
                     </dxo-label>     

                 </dxi-item>

                 <dxi-item
                     dataField="postcode"
             
                     [editorOptions]="{  width: 100, 
                                         height: 40, 
                                         placeholder: 'Enter Postcode', 
                                         inputAttr: { autocomplete: 'chrome-off'}
                                     }"
                 >
                     <dxo-label 
                         template="name"
                         text="Postcode"
                     >
                     </dxo-label>     

                 </dxi-item>

             </dxi-item>
             <!------------------------------------------------------------------------->
             <ng-container *ngFor="let label of labelTemplates">
                 <div *dxTemplate="let data of label.name">
                   <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                 </div>
             </ng-container>
             <!------------------------------------------------------------------------->
         </dx-form>
         <!------------------------------------------------------------------------->
     </dx-popup>
     <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
     <dx-toast
        [message]           =   "toastFileMessage"
        [visible]           =   "toastVisible"
        [type]              =   "toasttypeerror"
        [displayTime]       =   "toastdisplaytime"  
        [width]             =   "toastwidth" 
     >
                        
        <dxo-position>

            <dxo-at 
                x="left" 
                y="top">
            </dxo-at>

            <dxo-offset
                [x]="180" 
                [y]="20"
            >
            </dxo-offset>
            
        </dxo-position>

     </dx-toast>
     <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
</html>

